import { FileUploadErrorModalContent } from '@modules/integrationsV2/components/FileUploadModal/FileUploadErrorModalContent';
import { SelectedFileError } from '@modules/integrationsV2/types';
import {
  alpha,
  Box,
  CircularProgress,
  LinearProgress,
  Stack,
  Typography,
} from '@mui/material';
import { IntegrationType } from 'generated/graphql';
import { FileUploadCompletedModalContent } from './FileUploadCompletedModalContent';
import { FileUploadName } from './FileUploadName';

interface FileUploadModalContentProps {
  uploadProgress: number;
  fileName: string;
  selectedFileError: SelectedFileError | undefined;
  isFileUploadCompleted: boolean;
  integrationType: IntegrationType;
}

export const FileUploadModalContent = ({
  fileName,
  uploadProgress,
  selectedFileError,
  isFileUploadCompleted,
  integrationType,
}: FileUploadModalContentProps) => {
  if (selectedFileError) {
    return (
      <FileUploadErrorModalContent
        fileName={fileName}
        selectedFileError={selectedFileError}
      />
    );
  }

  if (isFileUploadCompleted) {
    return (
      <FileUploadCompletedModalContent
        fileName={fileName}
        integrationType={integrationType}
      />
    );
  }

  return (
    <Box
      p={1.25}
      border="1px solid"
      borderColor="divider"
      borderRadius={1}
      sx={{ background: (theme) => alpha(theme.palette.text.primary, 0.02) }}
    >
      <Stack spacing={2}>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Stack direction="row" alignItems="center" spacing={1.25}>
            <CircularProgress size={18} />
            <Typography>File Uploading</Typography>
          </Stack>
          <FileUploadName fileName={fileName} />
        </Stack>
        <LinearProgress
          variant="determinate"
          value={uploadProgress}
          sx={{ height: 8, borderRadius: 2 }}
        />
      </Stack>
    </Box>
  );
};
